/** Polyfills placeholder - add as needed for target browsers. */
// Zone JS is required by default for Angular's change detection.
// Import it here so it's loaded before Angular bootstraps.
import 'zone.js';

(window as any).global = window;
